export default __webpack_public_path__ + "static/media/screenshot_docs.6480e838.png";